<template>
  <v-container fluid>
    <v-row>
      <v-col
        sm='12'
        md='3'
      >
      <transition name="slide-fade" mode="out-in">
        <v-img
          :key="fetchImageName"
          contain
          max-height='300'
          :src="require(`@/assets/images/${fetchImageName}.png`)"
          :alt="dataOptions['Local Authority']"
        ></v-img>
      </transition>
      </v-col>
      <v-col
        sm='12'
        md='9'
        style='background-color:white'
      >
        <hr class='divider-primary' />
        <h6 class='header'>Trends and context</h6>
        <v-container fluid>
          <v-row class='
            d-flex pa-2
            justify-md-space-between
            justify-center
            flex-column
            flex-md-row'
          >
            <v-col
              class='pa-xs-4 pa-md-0 text-center'
              :key='index'
              v-for='(value,index) in trends'
            >
              <div class="gauge-container">
                <VueSvgGauge
                  :start-angle='0'
                  :end-angle='360'
                  :value='Number(parseFloat(value.total / 100 * 360).toFixed(1))'
                  :separator-step='0'
                  :min='0'
                  :max='360'
                  :gauge-color='colors[0]'
                  :base-color='colors[1]'
                  :scale-interval='0'
                >
                  <div class='inner-text'>
                    <v-container
                      fluid
                      fill-height
                    >
                      <v-row>
                        <v-col justify='center'>
                          <span>{{ value.total ? value.total : 'No Data' }}</span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                </VueSvgGauge>
              </div>
              <div class="sub-header-container">
                <span class="sub-header">{{value.header}}</span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="3">
        <hr class='divider-secondary' />
        <v-container>
          <v-row>
              <h6 class='header'>Workplaces</h6>
            <v-col sm="12">
              <span>Employees cycling to work regularly</span>
              <v-progress-linear
                color='#00486b'
                height='25'
                :value="parseFloat(dataOptions['Employees cycling to work usually/ regularly (%)'])"
              ></v-progress-linear>
              <span class="value">{{
              fixedPlace(dataOptions['Employees cycling to work usually/ regularly (%)'])
              }}
              </span>
            </v-col>
          </v-row>
          <v-row class='text-center'>
            <v-col sm="12">
              <span class="value">
                <b>{{dataOptions['Number of cycling friendly employers']}}</b>
              </span>
              <br />
              <span>Cycling Friendly Employers employing</span>
              <br />
              <span class="value">
                <b>{{dataOptions['Number of cycling friendly employees']}}</b>
              </span>
              <br />
              <span>staff</span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12" sm="12"  md="6">
        <hr class='divider-tertiary' />
        <h6 class='header'>Schools</h6>
        <v-container>
          <v-row>
            <v-col sm="12" md="6">
              <span>Pupils cycling to primary school ({{ getSelectedYear -2 }})</span>
              <v-progress-linear
                color='#00486b'
                height='25'
                :value="parseFloat(dataOptions['Pupils cycling to primary school (%)'])"
              ></v-progress-linear>
              <span class="value">{{
              fixedPlace(dataOptions['Pupils cycling to primary school (%)'])
              }}
              </span>
            </v-col>
            <v-col sm="12" md="6">
              <span>Pupils cycling to secondary school ({{ getSelectedYear -2 }})</span>
              <v-progress-linear
                color='#00486b'
                height='25'
                :value="dataOptions['Children cycling to secondary school (%)'] !== 'null' ?
                parseFloat(dataOptions['Children cycling to secondary school (%)']) : 0"
              ></v-progress-linear>
              <span class="value">
                {{
                  fixedPlace(dataOptions['Children cycling to secondary school (%)'])
                }}
              </span>
            </v-col>
          </v-row>
          <v-row class='text-center'>
            <v-col sm="6">
              <span class="value">
                <b>{{dataOptions['Number of cycling friendly schools']}}</b>
              </span>
              <br />
              <span>Cycling Friendly Schools reaching</span>
              <br />
              <span class="value">
                <b>{{dataOptions['Number of cycling friendly pupils']}}</b>
              </span>
              <br />
              <span>pupils cycling to secondary school</span>
            </v-col>
            <v-col sm="6">
              <span>
                Percentage of primary schools delivering Level 2 Bikeability Scotland
                training
              </span>
              <v-progress-linear
                color='#00486b'
                height='25'
                :value="dataOptions[
                  'Primary schools delivering level 2 Bikeability Scotland training (%)'
                ] !== 'null' ? parseFloat(dataOptions[
                  'Primary schools delivering level 2 Bikeability Scotland training (%)'
                ]) : 0"
              ></v-progress-linear>
              <span class="value">
                {{
                fixedPlace(
                  dataOptions[
                  `Primary schools delivering level 2 Bikeability Scotland training (%)`
                  ]
                )
                }}
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12" sm="12"  md="3">
        <hr class='divider-quad' />
        <h6 class='header'>Active travel budget</h6>
        <v-container class='text-center'>
          <v-row>
            <v-col>
              <span>Capital</span>
              <br />
              <span class="value">
                <b>{{budgetCapital}}</b>
              </span>
              <br />
              <span>Revenue</span>
              <br />
              <span class="value">
                <b>{{budgetRevenue}}</b>
              </span>
              <br />
              <span v-if="budgetStart">{{ budgetStart }}/{{budgetStart + 1}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>
                Method of financial calculations will vary by council.
                Figures provided by local area may not capture full spend.
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      colors: ['#004a6b', '#d0ecfa'],
      trends: [1, 2, 3],
      budgetRevenue: 'No data',
      budgetCapital: 'No data',
      budgetStart: '',
    };
  },
  computed: {
    ...mapGetters(['loadCheck', 'dataOptions', 'getSelectedYear', 'getSelectedAuthority']),
    fetchImageName() {
      if (this.dataOptions && this.dataOptions['Local Authority']) {
        return this.dataOptions['Local Authority'].split(' ').join('_');
      }
      return 'scotlandMap';
    },
  },
  methods: {
    launchStatisticsFetch() {
      this.$store.dispatch('fetchStatisticsData', {
        authority: this.getSelectedAuthority,
        year: this.getSelectedYear,
      });
    },
    fixedPlace(value) {
      if (value && value !== 'null') {
        return `${parseFloat(value).toFixed(1)}%`;
      }
      return 'No data';
    },
  },
  watch: {
    loadCheck(n) {
      if (n) {
        // do something
        this.$store.commit('toggleLoading', true);
        this.launchStatisticsFetch();
      }
    },
    dataOptions(n) {
      if (n) {
        const newTrends = [];
        newTrends.push({
          header: 'Proportion of journeys under 5km (%)',
          total: n['Proportion of journeys under 5km (%)'] !== 'null' ? `${n['Proportion of journeys under 5km (%)']}%` : null,
        });
        newTrends.push({
          header: 'Households with access to one or more bikes for private use (%)',
          total: n['Households with access to one or more bikes for private use (%)'] !== 'null' ? `${n['Households with access to one or more bikes for private use (%)']}%` : null,
        });
        newTrends.push({
          header: 'Households with no access to a car for private use (%)',
          total: n['Households with no access to a car for private use (%)'] !== 'null' ? `${n['Households with no access to a car for private use (%)']}%` : null,
        });
        this.trends = newTrends;
        this.budgetRevenue = n['Active Travel Budget Revenue (£)'] !== 'null'
          ? `£${Math.round(n['Active Travel Budget Revenue (£)'])}`
          : 'No data';
        this.budgetCapital = n['Active Travel Budget Capital (£)'] !== 'null'
          ? `£${Math.round(n['Active Travel Budget Capital (£)'])}`
          : 'No data';
        this.budgetStart = n['Budget FY Start'] !== 'null' ? parseInt(n['Budget FY Start'], 10) : '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all .1s ease-in-out;
}

.slide-fade-leave-active {
  transition: all .3s ease-in-out;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

@mixin dividerColour($color-main) {
  background-color: $color-main;
  color: $color-main;
}

#statisticsContainer {
  width: 100%;
  height: 100%;
  background-color: red;
}

.header {
  color: #00486b;
  font-weight: bold;
  font-size: 2em;
}

.sub-header {
  color: #5a5959;
  font-size: 1rem;
}

.sub-header-container {
  margin: 15px 0 0;
}

.value {
  color: #5a5959;
  font-weight: bold;
  font-size: 1.5rem;
}

%divider-shared {
  border: none;
  height: 0.5em;
}

.inner-text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8em;
  color: black;
  font-weight: 700;
}

span {
  color: #5a5959;
  font-size: 1em;
  margin: 1em 0;
}

.gauge-container {
  height: 200px;
  width: 200px;
  margin: auto
}

@media (min-width: 960px) {
  .gauge-container {
    height: 150px;
    width: 150px;
    margin: auto
  }
}

@media (min-width: 1264px) {
  .gauge-container {
    height: 200px;
    width: 200px;
    margin: auto
  }
}

.divider-primary {
  @extend %divider-shared;
  @include dividerColour(#ed6d91);
}

.divider-secondary {
  @extend %divider-shared;
  @include dividerColour(#fdcb22);
}

.divider-tertiary {
  @extend %divider-shared;
  @include dividerColour(#1db0db);
}

.divider-quad {
  @extend %divider-shared;
  @include dividerColour(#158001);
}
</style>
